module.exports = __webpack_public_path__ + "static/img/VE@2x.64bc6f47.jpg";